import { axiosInstance } from "@/helper/axios-instance";
import { DataAwareResponse, DocumentTemplate } from "../types/types";
import { useMutationWithValidation } from "./useMutationWithValidation";

export function useDocumentTemplateAdd() {
  return useMutationWithValidation({
    mutationFn: async (data: any) => {
      const res = await axiosInstance({
        method: "POST",
        url:  `DocumentTemplate/Add`,
        data: data,
      });

      return res.data as DataAwareResponse<DocumentTemplate>;
    },
    retry: 2,
  });
}
